/**
 * API endpoints
 */
const ENDPOINTS = {
  v1: {
    filter: '/v1/filter',
    autocomplete: '/v1/autocomplete',
    employee: '/v1/employee',
    employees: '/v1/employees',
    downloadExports: '/v1/download/excel/exports',
  },
};

export default ENDPOINTS;
